import { ErrorHandler, Injectable, inject } from '@angular/core';
import { BpErrorHandlerService } from '@bp-core/src/lib/modules/grpc-error';
import { BpConfirmationService } from 'bp/shared/services/bp-confirmation.service';

/**
 * `ErrorHandler` de desarrollo: muestra en un diálogo todo error no controlado.
 *
 * Vive en su propio archivo (antes estaba dentro de `app.module.ts`), como en el portal
 * (`bp-portal/src/app/develop-error-handler.service.ts`), para poder probarlo sin cargar `AppModule`.
 */
@Injectable()
export class DevelopErrorHandler implements ErrorHandler {
  private readonly bpConfirmationService = inject(BpConfirmationService);
  private readonly errorHandler = inject(BpErrorHandlerService);

  handleError(error: any) {
    const whiteList = ['Argumento de constructor de matriz con tipo no válido', '_avast_submit'];

    whiteList.forEach(element => {
      if (error.message?.includes(element)) {
        console.error('white-list error:', [error]);
        return;
      }
    });

    console.log(error);

    console.error('dev error handler:', error);
    // Un error de gRPC sin `error` en la llamada llega acá después de que el interceptor global ya
    // lo mostró (070, T047): un solo diálogo por error. Y, como en el portal, si ya hay un diálogo
    // abierto no se suma otro.
    if (
      this.errorHandler.wasDisplayed(error) ||
      this.bpConfirmationService.openDialogs().length > 0
    ) {
      return;
    }

    this.bpConfirmationService.open(
      {
        title: 'Error no controlado: ' + error.name,
        message: error.message,
      },
      'error',
    );
  }
}
